import {
  Box,
  Container,
  LinearProgress,
  Link as MuiLink,
  Stack,
  Typography,
} from "@mui/material";
import { AccountButton } from "@ssf/auth-components";
import { SSFCircleLogo } from "@ssf/components";
import { useIsFetching } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

import { generatePath } from "../lib/index.js";

export const Header = () => {
  const { t } = useTranslation("Header");
  const isFetching = useIsFetching();

  return (
    <>
      <LinearProgress
        value={100}
        variant={isFetching ? "indeterminate" : "determinate"}
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 100,
          "> span": { background: ({ palette }) => palette.primary.main },
        }}
      />
      <Container sx={{ maxWidth: "100% !important" }}>
        <Stack
          spacing={1}
          direction="row"
          sx={{
            alignItems: "center",
            minHeight: 48,
          }}
        >
          <MuiLink
            component={Link}
            to={generatePath("tournaments", {})}
            sx={{
              mr: "auto",
              svg: { width: 32, mr: 0.5 },
              display: "flex",
              alignItems: "center",
              textDecoration: "none",
            }}
          >
            <SSFCircleLogo />
            <Typography component="h1" variant="h4" color="textPrimary">
              {t("title")}
            </Typography>
          </MuiLink>

          <Box sx={{ flexGrow: 1 }} />

          <AccountButton />
        </Stack>
      </Container>
    </>
  );
};
